import { gql } from '@apollo/client';

const ERRORS = `errors { path, message }`;

const EVENT_CORE_FIELDS = gql`
  fragment EventCoreFields on Event {
    id
    eventAt
    timeType
    notes
    amount
    duration
    durationDescription
    createdAt
    updatedAt
  }
`;

export const EVENT_FIELDS = gql`
  ${EVENT_CORE_FIELDS}
  fragment EventFields on Event {
    ...EventCoreFields
    client { id, name }
    eventType { id, name, amountLabel }
    things { id, name, emoji }
  }
`;

export const EVENT = gql`
  ${EVENT_FIELDS}
  query Event($id: ID!) {
    event(id: $id) {
      ...EventFields
      eventThings {
        id
        thing { id, name }
        notes
      }
    }
  }
`;

export const EVENTS = gql`
  ${EVENT_FIELDS}
  query Events ($filters: EventsFiltersInput) {
    events (filters: $filters) {
      ...EventFields
    }
  }
`;

export const CREATE_EVENT = gql`
  ${EVENT_CORE_FIELDS}
  mutation CreateEvent ($input: CreateEventInput!) {
    createEvent (input: $input) {
      event {
        ...EventCoreFields
      }
      ${ERRORS}
    }
  }
`;

export const UPDATE_EVENT = gql`
  ${EVENT_CORE_FIELDS}
  mutation UpdateEvent ($input: UpdateEventInput!) {
    updateEvent (input: $input) {
      event {
        ...EventCoreFields
      }
      ${ERRORS}
    }
  }
`;

export const DESTROY_EVENT = gql`
  mutation DestroyEvent ($input: DestroyEventInput!) {
    destroyEvent (input: $input) {
      ${ERRORS}
    }
  }
`;

export const EVENT_SELECTS = gql`
  query EventSelects {
    clients {
      id
      name
    }
    eventTypes {
      id
      name
      emoji
      hasAmount
      amountLabel
      hasDuration
      hasThings
    }
  }
`;
